import React from 'react'

class AccidentModalRepairs extends React.PureComponent {
  render() {
    return (
      <div>
        <p>
          You can rest assured that your car will be repaired to the highest
          standards by our Citygate accident aftercare specialists. To make the
          process even easier, we offer a collection and delivery service. We
          will deliver a courtesy car to your house and collect it again once
          the work is complete on your vehicle.
        </p>
      </div>
    )
  }
}

export default AccidentModalRepairs
